import type { App } from 'vue';
import { withSentry } from './with-sentry';
import { withAnalytics } from './with-analytics';
import { withCfTurnstile } from './with-cf-turnstile';

export const withProviders = (app: App) => {
  const sentry = withSentry(app);
  withAnalytics(sentry?.captureException);
  withCfTurnstile();
};
